/**
 * Created by mukund on 2/7/17.
 */

angular.module('mediacloudApp')
    .directive( 'treecontrol', ['$compile', function( $compile ) {
        return {
            restrict: 'E',
            require: "treecontrol",
            replace: true,
            template: '<ul class="tree-classic" role="menu" aria-labelledby="destinationSelection"></ul>',
            transclude: true,
            scope: {
                treeModel: "=",
                selectedNode: "=",
                onSelection: "&",
                nodeChildren: "@"
            },
            controller: function( $scope ) {

                // The name of the children array. If this is not set as an attribute, we use the name 'children'
                $scope.nodeChildren = $scope.nodeChildren || 'children';

                $scope.expandedNodes = {};

                // Determine what class to apply depending on the state of the subtree
                $scope.headClass = function(node) {
                    if (node[$scope.nodeChildren].length && !$scope.expandedNodes[this.$id])
                        return "tree-collapsed";
                    else if (node[$scope.nodeChildren].length && $scope.expandedNodes[this.$id])
                        return "tree-expanded";
                    else
                        return "tree-normal"
                };

                $scope.nodeExpanded = function() {
                    return $scope.expandedNodes[this.$id];
                };

                $scope.selectNodeHead = function() {
                    $scope.expandedNodes[this.$id] = !$scope.expandedNodes[this.$id];
                };

                $scope.selectNodeLabel = function( selectedNode ){
                    $scope.selectedScope = this.$id;
                    $scope.selectedNode = selectedNode;
                    if ($scope.onSelection)
                        $scope.onSelection({node: selectedNode});
                };

                $scope.selectedClass = function() {
                    return (this.$id == $scope.selectedScope)?"tree-selected":"";
                };

                //tree template
                var template =
                    '<ul>' +
                    '<li ng-repeat="node in node.' + $scope.nodeChildren + '" ng-class="headClass(node)" role="menuitem">' +
                    '<i tabindex="0" role="link" class="fa fa-caret-down collapsearrow" aria-hidden="true" ng-click="selectNodeHead(node)"></i>' +
                    '<i tabindex="0" role="link" class="fa fa-caret-right collapsearrow" aria-hidden="true" ng-click="selectNodeHead(node)"></i>' +
                    '<div class="tree-has-children tree-icon" ng-click="selectNodeHead(node)"></div>' +
                    '<div class="tree-normal tree-icon"></div>' +
                    '<div tabindex="0" role="link" class="tree-label" ng-class="selectedClass()" ng-click="selectNodeLabel(node)" tree-transclude></div>' +
                    '<treeitem ng-if="nodeExpanded()"></treeitem>' +
                    '</li>' +
                    '</ul>';

                return {
                    templateRoot: $compile(template),
                    templateChild: $compile(template)
                }
            },
            compile: function(element, attrs, childTranscludeFn) {
                return function ( scope, element, attrs, treemodelCntr ) {

                    function updateNodeOnRootScope(newValue) {
                        if (angular.isArray(newValue)) {
                            scope.node = {};
                            scope.node[scope.nodeChildren] = newValue;
                        }
                        else {
                            scope.node = newValue;
                        }
                    }
                    scope.$watch("treeModel", updateNodeOnRootScope);
                    updateNodeOnRootScope(scope.treeModel);

                    //Rendering template for a root node
                    treemodelCntr.templateRoot( scope, function(clone) {
                        element.html('').append( clone );
                    });
                    // save the transclude function from compile (which is not bound to a scope as apposed to the one from link)
                    // we can fix this to work with the link transclude function with angular 1.2.6. as for angular 1.2.0 we need
                    // to keep using the compile function
                    scope.$treeTransclude = childTranscludeFn;
                }
            }
        };
    }])
    .directive("treeitem", function() {
        return {
            restrict: 'E',
            require: "^treecontrol",
            link: function( scope, element, attrs, treemodelCntr) {

                // Rendering template for the current node
                treemodelCntr.templateChild(scope, function(clone) {
                    element.html('').append(clone);
                });
            }
        }
    })
    .directive("treeTransclude", function() {
        return {
            link: function(scope, element, attrs, controller) {
                scope.$treeTransclude(scope, function(clone) {
                    element.empty();
                    element.append(clone);
                });
            }
        }
    });
